import { getImageId } from 'common/utils/image';
import { IBasicFileFragment } from 'graphql/types';

export function getVideoThumbnailId(
    videoId: string,
    currentThumbnail?: IBasicFileFragment | null,
    newThumbnail?: IBasicFileFragment | null
) {
    const thumbnailId = getImageId(currentThumbnail, newThumbnail);

    if (thumbnailId === undefined || thumbnailId === null) {
        return thumbnailId;
    }

    // Provider thumbnails use the video id as a synthetic file id on the API.
    if (thumbnailId === videoId) {
        return undefined;
    }

    return thumbnailId;
}
